import { render } from "./PolicyClientComponent.vue?vue&type=template&id=86bb1092&scoped=true"
import script from "./PolicyClientComponent.vue?vue&type=script&lang=js"
export * from "./PolicyClientComponent.vue?vue&type=script&lang=js"

import "./PolicyClientComponent.vue?vue&type=style&index=0&id=86bb1092&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bb1092"]])

export default __exports__